import { Injectable } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';
import { ConstantsService } from './constants.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { Http, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class SocioFondeadorService {

  private service_url;

  constructor(
    private constantsService: ConstantsService, 
    private http: Http,
    private authService: AutenticacionService, 
    private validatorService: ValidatorService, 
    private errorService: ErrorsService,
    private cookieService: CookieService
  ) { 
    this.service_url = this.constantsService.apiURL + '/socios-fondeadores';
  }

  getDefaultSchedule() {
    return {
      'tipo_fondeador': null,
      'nombre': '',
      'email':'',
      'idSucursal': '',
      'telefono': '',
      'tipo_entidad': '',
      'rfc': '',
      'direccion': '',
      'saldo': '',
      'clave_elector': '',
      'archivo_ine': null,
      'archivo_domicilio': null,
      'archivo_rfc': null,
    };
  }

  esquemaAumentoSaldo() {
    return {
      'idFondeador': '',
      'idSocio': '',
      'fecha_incremento_saldo':'',
      'forma_pago':'',
      'banco': null,
      'num_clabe_tarjeta': null,
      'num_referencia':'',
      'monto_saldo':''
    };
  }

  esquemaRetiroSaldo() {
    return {
      'idFondeador': '',
      'idSocio': '',
      'fecha_retiro_saldo':'',
      'forma_pago':'',
      'banco': null,
      'tipo_clabe_tarjeta': null,
      'num_clabe_tarjeta': null,
      'num_referencia':'',
      'monto_saldo':'',
      'idEsquema':0,
      'Extra':''
    };
  }

  public validarSocio(data){
    console.log("Validando... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["nombre"])){
      error["nombre"] = this.errorService.required;
    }

    // validacion de EMAIL
    data["email"] = data["email"].trim();
    // console.log("DataValidator: ", data);
    
    if(!this.validatorService.required(data["email"])){
      error["email"] = this.errorService.required;
    }
    else if(!this.validatorService.max(data["email"], 40)){
      error["email"] = this.errorService.max(40);
    }
    else if (!this.validatorService.email(data['email'])) {
      error['email'] = this.errorService.email;
    }

    if(!this.validatorService.required(data["idSucursal"])){
      error["idSucursal"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["telefono"])){
      error["telefono"] = this.errorService.required;
    }else if(!this.validatorService.numeric(data["telefono"])){
      error["telefono"] = this.errorService.numeric;
    }else if(!this.validatorService.min(data["telefono"], 10)){
      error["telefono"] = this.errorService.min(10);
    }else if(!this.validatorService.max(data["telefono"], 10)){
      error["telefono"] = this.errorService.max(10);
    }

    if(!this.validatorService.required(data["tipo_entidad"])){
      error["tipo_entidad"] = this.errorService.required;
    }
    
    if(!this.validatorService.required(data["rfc"])){
      error["rfc"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["direccion"])){
      error["direccion"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["saldo"])){
      error["saldo"] = this.errorService.required;
    }
    //Validar clave de elector para personas físicas
    if(data["tipo_entidad"] === "fisica"){
      if(!this.validatorService.required(data["clave_elector"])){
        error["clave_elector"] = this.errorService.required;
      }
    }
    // if(!this.validatorService.required(data["tipo_fondeador"])){
    //   error["tipo_fondeador"] = this.errorService.required;
    // }

    return error;
  }

  public validarAumentoSaldo(data: any){
    console.log("Validando... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["fecha_incremento_saldo"])){
      error["fecha_incremento_saldo"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["forma_pago"])){
      error["forma_pago"] = this.errorService.required;
    }

    if(!this.validatorService.required(data["num_referencia"])){
      error["num_referencia"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["monto_saldo"])){
      error["monto_saldo"] = this.errorService.required;
    }
    
    return error;
  }

  public validarRetiroSaldo(data: any){
    console.log("Validando retiro... ", data);
    
    let error = [];

    if(!this.validatorService.required(data["fecha_retiro_saldo"])){
      error["fecha_retiro_saldo"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["forma_pago"])){
      error["forma_pago"] = this.errorService.required;
    }

    if(data["forma_pago"] == "transferencia" || data["forma_pago"] == "tarjeta"){
      if(!this.validatorService.required(data["banco"])){
        error["banco"] = this.errorService.required;
      }
      if(!this.validatorService.required(data["num_clabe_tarjeta"])){
        error["num_clabe_tarjeta"] = this.errorService.required;
      }
    }

    if(!this.validatorService.required(data["num_referencia"])){
      error["num_referencia"] = this.errorService.required;
    }
    if(!this.validatorService.required(data["monto_saldo"])){
      error["monto_saldo"] = this.errorService.required;
    }

    if(data["Extra"] != ""){
      if(!this.validatorService.required(data["idEsquema"])){
        error["idEsquema"] = this.errorService.required;
      }

    }
    return error;
  }
  //Registrar nuevo socio
  public registrarSocioFondeador(data) {
    return this.http.post(this.service_url+"/registro", data, this.authService.getAuthHeaders());
  }

  //Obtener fondeadores con paginación
  public obtenerSociosFondeadores(page:any, filters:any) {
    let myParams = new URLSearchParams();
    if(filters.page){
      myParams.append('paginate', 'true');
      myParams.append('page', filters.page);
    }
    if(filters.search){
      myParams.append('search', filters.search);
    }
    
    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    console.log(myParams);
    return this.http.get(this.service_url +"/lista" , myoptions);
    // if (page) {
    //   return this.http.get(this.service_url+"/lista" + '?paginate=true&page=' + page , this.authService.getAuthHeaders());
    // }
    // return this.http.get(this.service_url +"/lista"+ '?paginate=true', this.authService.getAuthHeaders());
  }

  //Obtiene fondeador especifico
  public getSocioEspecifico(id){
    return this.http.get(this.service_url +"/registro?idFondeador="+id, this.authService.getAuthHeaders());
  }
  //Obtener socio por ID
  public getSocioById(id){
    return this.http.get(this.service_url +"/perfil-socio?idFondeador="+id, this.authService.getAuthHeaders());
  }

  public getRetirosSaldoId(id){
    return this.http.get(this.service_url +"/retiro-saldo?idFondeador="+id, this.authService.getAuthHeaders());
  }

  public getIncrementosSaldoId(id){
    return this.http.get(this.service_url +"/incremento-saldo?idFondeador="+id, this.authService.getAuthHeaders());
  }

  public update(id, data) {
    return this.http.put(this.service_url +'?id='+ id, data, this.authService.getAuthHeaders());
  }

  public delete(id) {
    return this.http.delete(this.service_url +'?id='+ id, this.authService.getAuthHeaders());
  }
  
  //Registrar aumento de saldo
  public registrarIncrementoSaldo(data) {
    return this.http.post(this.service_url+"/incremento-saldo", data, this.authService.getAuthHeaders());
  }

  //Registrar retiro de saldo
  public registrarRetiroSaldo(data) {
    return this.http.post(this.service_url+"/retiro-saldo", data, this.authService.getAuthHeaders());
  }

  //Aceptar retiro de saldo
  public aceptarRetiroSaldo(id: number) {
    var data = {
      "estatus": true
    }
    return this.http.put(this.service_url+"/retiro-saldo?id="+id, data, this.authService.getAuthHeaders());
  }

  //Rechazar retiro de saldo
  public rechazarRetiroSaldo(id: number) {
    return this.http.delete(this.service_url+"/retiro-saldo?id="+id, this.authService.getAuthHeaders());
  }

  public aceptarIngresoSaldo(id: number) {
    var data = {
      "estatus": true
    }
    return this.http.put(this.service_url+"/incremento-saldo?id="+id, data, this.authService.getAuthHeaders());
  }

  public rechazarIngresoSaldo(id: number) {
    return this.http.delete(this.service_url+"/incremento-saldo?id="+id, this.authService.getAuthHeaders());
  }
}



// WEBPACK FOOTER //
// ./src/app/services/socio-fondeador.service.ts